import Axios from "../util/axiosInstance";

export const SendFeedbackApi = (payload) => {
  return Axios.post("/api/Feedback/SendFeedback", payload)
};